import React, { useState } from "react";
import "./Marketing.css";

import Banners from "./Banners/Banners";
import Campaigns from "./Campaigns/Campaigns";

export default function Marketing() {
  const [activeTab, setActiveTab] = useState("BANNERS");

  return (
    <div className="marketing-page">

      {/* Header */}
      <div className="marketing-header">

        <div>
          <h1>📢 Marketing</h1>
          <p>
            Manage promotional banners, campaigns and future marketing activities.
          </p>
        </div>

      </div>

      {/* Tabs */}

      <div className="marketing-tabs-container">

        <button
          className={`marketing-tab ${
            activeTab === "BANNERS" ? "active" : ""
          }`}
          onClick={() => setActiveTab("BANNERS")}
        >
          🖼️ Banners
        </button>

        <button
          className={`marketing-tab ${
            activeTab === "CAMPAIGNS" ? "active" : ""
          }`}
          onClick={() => setActiveTab("CAMPAIGNS")}
        >
          📢 Campaigns
        </button>

      </div>

      {/* Content */}

      <div className="marketing-content-card">

        {activeTab === "BANNERS" && <Banners />}

        {activeTab === "CAMPAIGNS" && <Campaigns />}

      </div>

    </div>
  );
}